import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoCmStep2Component
} from './conservazione-carica-documento-cm-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.conservazione-carica-documento-cm-step2', {
      url: '/conservazione-carica-CM',
      ncyBreadcrumb: {
        label: 'Carica CM',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      views: {
        homeContent: {
          template: '<conservazione-carica-documento-cm-step2 flex="100"></conservazione-carica-documento-cm-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoCmStep2Module: string = ng
  .module('conservazione-carica-documento-cm-step2', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('conservazioneCaricaDocumentoCmStep2', ConservazioneCaricaDocumentoCmStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-cm-step2/conservazione-carica-documento-cm-step2.module.ts